<script setup lang="ts">
import type { IProps } from './Infoline.types'

defineProps<IProps>()
</script>

<template>
  <div class="infoline">
    <h6
      v-if="heading"
      class="infoline__heading"
    >
      {{ heading }}
    </h6>

    <div
      v-if="items.length > 0"
      class="infoline__contact"
    >
      <div
        v-for="(item, index) in items"
        :key="`infoline__contact-item-${index}`"
      >
        <div class="infoline__contact-item">
          <p>{{ $t(item.text) }}</p>
          <p v-html="$t(item.value)"/>
        </div>
      </div>
      <p
        v-if="availability"
        class="infoline__contact--comment"
      >
        {{ availability }}
      </p>
    </div>

    <div
      v-if="!hideGraphic"
      class="infoline__graphic"
    >
      <img
        width="147"
        height="147"
        class="infoline__image-icon"
        src="/images/send-us-message.svg"
      >

      <img
        class="infoline__image"
        src="/images/career/reference/benefitsystems-career-form-reference.jpeg"
      >
    </div>
  </div>
</template>

<style scoped lang="scss">
.infoline {
  &__heading {
    @include h7;
    display: inline-block;
    margin-bottom: 3.2rem;
  }

  &__contact {
    margin-bottom: 3.2rem;

    &-item {
      display: flex;
      align-items: center;
      margin-bottom: 0.8rem;
      font-weight: 500;
      font-size: 1.8rem;
      line-height: 2.4rem;

      p {
        width: 100%;
        height: 4.8rem;
        padding-top: 1.2rem;
        padding-bottom: 1.2rem;
        color: $text-300;
        border-bottom: 1px solid $gray-400;
      }

      p:first-of-type {
        width: 8rem;
        color: $text-400;
        border-right: 1px solid $gray-400;
      }

      p:nth-of-type(2) {
        padding-left: 1.6rem;
      }
    }

    &--comment {
      @include body-1-medium;
      margin-top: 3.2rem;
      margin-bottom: 6.4rem;
      color: $text-200;
      font-weight: 400;
    }
  }

  &__graphic {
    position: relative;
    max-width: 80rem;
    margin-top: 9.6rem;
    margin-bottom: 3.2rem;
    border-radius: 2.4rem;
  }

  &__image {
    max-width: 100%;
  }

  &__image-icon {
    position: absolute;
    top: -7.5rem;
    right: -1.5rem;

    @include atM {
      right: -7.5rem;
    }
  }
}
</style>
